import { Stack } from '@mui/material';
import EditableInstructionCard from './EditableInstructionCard';
import { useInstructions } from './useInstructions';
import { AiSupportInstructionProperties } from '@server/ai';
import usePermission from '../../../common/permissions/usePermission';

interface InstructionsListProps {
  instructions: AiSupportInstructionProperties[];
  onIsPristineChange: (id: string, isPristine: boolean) => void;
}

export const InstructionsList = ({ instructions, onIsPristineChange }: InstructionsListProps) => {
  const { updateInstruction, deleteInstruction } = useInstructions();
  const [isDeleteAllowed, isUpdateAllowed] = usePermission([
    //one permission for all actions by design
    'create:ai-sessions',
    'create:ai-sessions',
  ]);

  return (
    <Stack gap={2} pt={2}>
      {instructions?.map((instruction) => (
        <EditableInstructionCard
          key={instruction.id}
          card={instruction}
          isDeleteAllowed={isDeleteAllowed}
          isUpdateAllowed={isUpdateAllowed}
          onUpdateOrCreate={updateInstruction}
          onRemove={deleteInstruction}
          onIsPristineChange={onIsPristineChange}
        />
      ))}
    </Stack>
  );
};
